export default __webpack_public_path__ + "static/widgets-72fd3fd80baef9990109c8eb30d1cca9.png";